import { createComponent } from '@carvana/merch-components';

export const Card = createComponent('div', {
  className:
    'flex h-auto flex-col gap-2xl rounded-[6px] border-[1px] border-solid border-grey-2 bg-white p-2xl m:h-[446px] m:justify-around m:gap-0 m:p-4xl',
  'data-qa': 'purchase-in-progress-card'
});

export const cardWrapperStyles = 'l:col-span-2';

export const buttonStyles = 'w-full m:w-[291px]';

export const TitleWrapper = createComponent('div', {
  className: 'flex flex-col gap-md'
});

export const Title = createComponent('p', {
  className: 'text-blue-6 tl-header-m m:tl-header-xl',
  'data-qa': 'purchase-in-progress-title'
});

export const SubTitle = createComponent('p', {
  className: 'text-grey-5 tl-body-m m:tl-body-l',
  'data-qa': 'purchase-in-progress-text'
});

export const DetailsWrapper = createComponent('div', {
  className:
    'flex h-fit flex-col-reverse  gap-xl m:flex-row m:justify-between m:gap-4xl'
});

export const DetailsContentWrapper = createComponent('div', {
  className: 'flex flex-shrink-0 flex-col justify-center gap-2xl'
});

export const YMMTMWrapper = createComponent('div', {
  className: 'flex flex-col gap-4 text-blue-6 m:gap-8'
});

export const YMM = createComponent('p', {
  className: 'tl-header-s m:tl-header-m',
  'data-qa': 'purchase-in-progress-year-make-model'
});

export const TrimMileage = createComponent('p', {
  className: 'flex items-center gap-8 tl-body-s m:tl-body-m',
  'data-qa': 'purchase-in-progress-trim'
});

export const BlueDot = createComponent('div', {
  className: 'h-4 w-4 rounded-full bg-blue-6'
});

export const ImageContainer = createComponent('div', {
  className: 'flex aspect-video w-full items-center m:w-full m:max-w-[450px]'
});

export const Image = createComponent('img', {
  className: 'aspect-video w-full rounded-[6px] object-cover',
  'data-qa': 'purchase-in-progress-image'
});
